import { Navigate } from "react-router-dom";
import { useAuth } from "react-oidc-context"
import { useEffect } from "react";

interface ProtectedProps {
  children: JSX.Element; 
}

const Protected: React.FC<ProtectedProps> = ({ children }): JSX.Element => {
  const auth = useAuth();
  const isLoggedIn = auth.isAuthenticated && !auth.isLoading;

  useEffect(() => {
    if (!isLoggedIn && !auth.isLoading) {
      auth.signinRedirect();
    }
  }, [auth, isLoggedIn]);

  if (!isLoggedIn) {
    return <div>Redirecting to login...</div>;
  }

  return children;
};

export default Protected;